import {
  DEFAULT_PRINT_PAGE_SIZE,
  PRINT_PAGE_SIZES,
} from 'constants/printPageSize';

// Layout tokens for the put-away instruction template in utils/pdfGenerators.
// The document is a portrait table grouped by shelf, so both sizes are portrait.
const PUT_AWAY_INSTRUCTION_PRINT_LAYOUTS = {
  [PRINT_PAGE_SIZES.LABEL_4X6]: {
    pageSize: '100mm 150mm',
    pageMargin: '5mm',
    bodyWidth: '90mm',
    bodyHeight: '140mm',
    bodyFontSize: '7px',
    cellFontSize: '6px',
    cellPadding: '1px',
    titleFontSize: '10px',
    headerFontSize: '7px',
    shelfFontSize: '8px',
  },
  [PRINT_PAGE_SIZES.A4]: {
    pageSize: 'A4',
    pageMargin: '10mm',
    bodyWidth: '190mm',
    bodyHeight: null,
    bodyFontSize: '11px',
    cellFontSize: '10px',
    cellPadding: '3px',
    titleFontSize: '18px',
    headerFontSize: '11px',
    shelfFontSize: '12px',
  },
};

export const getPutAwayInstructionPrintLayout = pageSize =>
  PUT_AWAY_INSTRUCTION_PRINT_LAYOUTS[pageSize] ??
  PUT_AWAY_INSTRUCTION_PRINT_LAYOUTS[DEFAULT_PRINT_PAGE_SIZE];
